import { useState } from "react";
import ThriveTitle from "../../common/ThriveTitle";
import dayjs from "dayjs";
import BusinessActionPlanCard from "./BusinessActionPlanCard";
import { Box, Button, Stack } from "@mui/material";
import { axiosInstance } from "../../../utils/networking";
import {
  BusinessActionPlanType,
  defaultBusinessActionPlan,
} from "../../../interfaces";
import { StyledButtonMain } from "../../common/Buttons";

type BusinessActionPlanEditProps = {
  setOpen: (open: boolean) => void;
  actionPlan: BusinessActionPlanType;
  setActionPlan: (actionPlan: BusinessActionPlanType) => void;
  handleSave: () => void;
  handleComplete: () => void;
  handleExtend: () => void;
  handleDelete: () => void;
  handleNewClose?: () => void;
};

const BusinessActionPlanEdit: React.FC<BusinessActionPlanEditProps> = ({
  setOpen,
  actionPlan,
  setActionPlan,
  handleSave,
  handleComplete,
  handleExtend,
  handleDelete,
  handleNewClose,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <ThriveTitle
        title={"Add/Edit Business Action Plan"}
        setOpen={setOpen}
        onClose={handleNewClose}
      ></ThriveTitle>
      <BusinessActionPlanCard
        enableEdit={true}
        actionPlan={actionPlan}
        setActionPlan={setActionPlan}
      ></BusinessActionPlanCard>
      <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
        <StyledButtonMain
          variant="contained"
          sx={{
            width: "200px",
            fontSize: "20px",
            margin: "auto",
            marginTop: "10px",
          }}
          onClick={handleSave}
        >
          SAVE
        </StyledButtonMain>
        <StyledButtonMain
          variant="contained"
          sx={{
            width: "200px",
            fontSize: "20px",
            margin: "auto",
            marginTop: "10px",
          }}
          onClick={handleComplete}
        >
          COMPLETE
        </StyledButtonMain>
        <StyledButtonMain
          variant="contained"
          sx={{
            width: "200px",
            fontSize: "20px",
            margin: "auto",
            marginTop: "10px",
          }}
          onClick={handleExtend}
        >
          EXTEND
        </StyledButtonMain>
        <Button
          variant="contained"
          color="error"
          sx={{
            width: "200px",
            fontSize: "20px",
            margin: "auto",
            marginTop: "10px",
          }}
          onClick={handleDelete}
        >
          DELETE
        </Button>
      </Stack>
    </Box>
  );
};

export default BusinessActionPlanEdit;
